import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import {
  selectIsExpandedAiChats,
  selectIsCreateActive,
  setIsCreateActive,
  toggleExpandMode,
  setExpandMode,
} from './agentsHomeReducer';
import { useIsAgentsPanelOpen } from './useIsAgentsPanelOpen';
import { useOpenAgentsPanel } from './useOpenAgentsPanel';
import { useCloseAgentsPanel } from './useCloseAgentsPanel';

const useAgentsHome = () => {
  const isExpanded = useSelector(selectIsExpandedAiChats);
  const isCreateAgentActive = useSelector(selectIsCreateActive);

  const isOpened = useIsAgentsPanelOpen();
  const openAgentsPanel = useOpenAgentsPanel();
  const closeAgentsPanel = useCloseAgentsPanel();

  const dispatch = useDispatch();

  const toggleIsExpanded = useCallback(() => {
    dispatch(toggleExpandMode());
  }, [dispatch]);

  const setIsExpanded = useCallback(
    ({ isExpanded }: { isExpanded: boolean }) => {
      dispatch(setExpandMode({ isExpanded }));
    },
    [dispatch],
  );

  const setIsAgentCreateActive = useCallback(
    (isActive: boolean) => {
      dispatch(setIsCreateActive({ isActive }));
      // When activating agent creation, close the panel
      if (isActive && isOpened) {
        closeAgentsPanel();
      }
    },
    [dispatch, isOpened, closeAgentsPanel],
  );

  return {
    isExpanded,
    toggleIsExpanded,
    openAgentsPanel,
    isOpened,
    setIsAgentCreateActive,
    isCreateAgentActive,
    closeAgentsPanel,
    setIsExpanded,
  };
};

export default useAgentsHome;
